import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import { createPortal } from "react-dom";

function SessionExpiredPopup({
  message = "Session expired. Please login again.",
}) {
  const navigate = useNavigate();

  const handleLogout = () => {
    try {
      const userInfo = localStorage.getItem("userInfo");
      const userId = userInfo ? JSON.parse(userInfo).userId : null;
      window.dataLayer.push({
        event: "logout",
        userId,
      });
      localStorage.removeItem("access_token");
      localStorage.removeItem("available_tokens");
      localStorage.removeItem("isAuthUser");
      localStorage.removeItem("isAdminUser");
      localStorage.removeItem("userInfo");
      localStorage.removeItem("dashboardTab");
      localStorage.removeItem("userProfileInfo");
      localStorage.removeItem("registerEmail");
      localStorage.removeItem("token");
      localStorage.removeItem("refresh");
      navigate("/login", { replace: true });
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };

  const popupContent = (
    <div className="fixed inset-0 z-[999999] bg-black/70 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-sm text-center relative animate-fadeIn">
        <p className="text-lg font-semibold text-gray-800">{message}</p>

        <div className="flex justify-center mt-6">
          <button
            onClick={handleLogout}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all duration-200"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );

  // Render popup outside all other elements
  return createPortal(popupContent, document.body);
}

export default SessionExpiredPopup;
